import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Router from 'vue-router';
import { store } from './store';
import BootstrapVue from 'bootstrap-vue';
import VueMoment from 'vue-moment';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee, faPenSquare, faTrash, faPen, faThumbsUp as fasThumbsUp, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp as farThumbsUp  } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Notifications from 'vue-notification';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import VueTextareaAutosize from 'vue-textarea-autosize';
Vue.use(VueTextareaAutosize);

import VueLodash from 'vue-lodash';
const options = { name: 'lodash' };
Vue.use(VueLodash);

import { domain, clientId, audience } from '../auth_config';
import { Auth0Plugin } from './auth';
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: (appState: any) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    );
  },
});

library.add(faPenSquare, faTrash, faPen, fasThumbsUp, farThumbsUp, faPhone );

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use( CKEditor, ClassicEditor );
Vue.use(VueMoment, { moment });
Vue.config.productionTip = false;
Vue.use(Router);
Vue.use(BootstrapVue);
Vue.use(Notifications);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
